const ms = require('ms');

export const defaultHttpTimeoutMs = ms('60s');

export const USER_SHOULD_VERIFY_ID_CARD = 'You must verify your account';
export const USER_SHOULD_VERIFY_SMS = 'You should verify with SMS';
export const COMPLETE_REGISTRATION = 'Complete registration';

export enum MarketAttribute {
    main = 'preselected',
}

export const smsLimitNotice = 'Ai atins numărul maxim de SMS-uri trimise, te rugăm să contactezi echipa de suport';

export const promotionsPrefix = 'P-';
export const pinnedSectionId = 'pinned';
export const superLiveId = 'superLive';
export const superLiveTag = 'superLive';
export const tonTenOrder = '3.5'; // between super cota and super extra, artificial order as a temporary workaround for deprecated superextra

export const competitorDelimiter = '·';

export enum SportId {
    Volleyball = 1,
    Tennis = 2,
    Football = 5,
    Badminton = 14,
    TableTennis = 24,
    BeachVolleyball = 28,
    BeachHandball = 86,
    Basketball = 4,
    Handball = 11,
    IceHockey = 3,
    Snooker = 6,
    CounterStrike = 55,
    AmericanFootball = 12,
    Box = 34,
    Mma = 40,
    Dota2 = 54,
    LeagueOfLegends = 39,
    Darts = 13,
    LandHockey = 7,
    Floorball = 9,
    Baseball = 20,
    AlpineSkiing = 46,
    AustralianFootball = 19,
    Basketball3x3 = 74,
    BeachFootball = 27,
    Bowls = 30,
    Chess = 35,
    Cricket = 32,
    Curling = 22,
    Cycling = 25,
    Entertainment = 42,
    FieldHockey = 29,
    Kabaddi = 76,
    RinkHockey = 71,
    Formula1 = 91,
    Futsal = 17,
    FootballSpecials = 168,
    MiniFootball = 170,
    GaelicFootball = 82,
    GaelicHurling = 84,
    Golf = 16,
    Lacrosse = 81,
    MotorcycleRacing = 93,
    Motorsport = 18,
    Netball = 169,
    Netball2 = 36,
    Pesapallo = 26,
    Rugby = 8,
    Speedway = 94,
    Squash = 38,
    Surfing = 173,
    Padel = 166,
    Padel2 = 227,
    Waterpolo = 15,
    WinterSports = 10,
    Athletics = 44,
    eSportArenaofValor = 85,
    eSportBasketball = 70,
    eSportCallofDuty = 61,
    eSportFortnite = 87,
    eSportIceHockey = 157,
    eSportKingofGlory = 88,
    eSportOverwatch = 53,
    eSportRainbowSix = 80,
    eSportRocketLeague = 83,
    eSportSmite = 89,
    eSportFootball = 75,
    eSportStarcraft = 57,
    eSportStarcraftII = 96,
    eSportValorant = 153,
    Olympics = 41,
    Sailing = 43,
    Swimming = 159,
    Gymnastics = 176,
    Judo = 180,
    Taekwondo = 178,
    Wrestling = 181,
    Rowing = 162,
    Fencing = 182,
    CanoeSlalom = 183,
    CanoeSprint = 184,
    SportClimbing = 185,
}

const tennisPeriodNames = ['G', 'S', 'M'];
const vtbPeriodNames = [
    'currentPeriodScore',
    'previousPeriodScore',
    'totalScore',
];
const defaultPeriodNames = [
    'totalScore',
    'currentPeriodScore',
    'previousPeriodScore',
];
const periodNamesMap: Record<SportId | number, string[]> = {
    [SportId.Tennis]: tennisPeriodNames,
    [SportId.Volleyball]: vtbPeriodNames,
    [SportId.TableTennis]: vtbPeriodNames,
    [SportId.BeachVolleyball]: vtbPeriodNames,
    [SportId.Football]: defaultPeriodNames,
    [SportId.Badminton]: defaultPeriodNames,
};

export function getPeriodNames(id: SportId | number) {
    return periodNamesMap[id] || defaultPeriodNames;
}

export enum OrderDirection {
    Asc = 'asc',
    Desc = 'desc',
}
